import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Paginator } from "primereact/paginator";
import { Ripple } from "primereact/ripple";
import { Nav } from "react-bootstrap";
import { Tab } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import CreateModal from "./CreateModal";
import UpdateModal from "./UpdateModal";
import UpdateModalTutorial from "./UpdateModalTutorial";
import UpdateModalKKD from "./UpdateModalKKD";
import { TitleContext } from "../../../../../Context/TitleContext";
import {
  API_URL,
  useAxios,
  rowsPerPageOptions,
} from "../../../../../utils/const";
import { useToast } from "../../../../../Context/ToastContext";
import moment from "moment";
import UpdateLecturerModal from "./UpdateLecturerModal";
import DeleteLecturerModal from "./DeleteLecturerModal";
import CheckOutModal from "./CheckOutModal";
import { Image } from "primereact/image";
import excelJS from "exceljs";
import { saveAs } from "file-saver";

const CourseAttendances = () => {
  const { setTitle } = useContext(TitleContext);
  const axiosInstance = useAxios();
  const { setToastObj } = useToast();
  const { id, course_type } = useParams();

  const MySwal = withReactContent(Swal);

  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [openUpdateLecturerModal, setOpenUpdateLecturerModal] = useState(false);
  const [openDeleteLecturerModal, setOpenDeleteLecturerModal] = useState(false);
  const [openCheckOutModal, setOpenCheckOutModal] = useState(false);

  const [courseSession, setCourseSession] = useState([]);

  const [courseStudents, setCourseStudents] = useState({
    courseStudents: [],
    totalRecords: 0,
  });
  const [courseStudentRecords, setCourseStudentRecords] = useState([]);
  const [selectedCourseStudent, setSelectedCourseStudent] = useState([]);

  const [courseLecturers, setCourseLecturers] = useState({
    courseLecturers: [],
    totalRecords: 0,
  });

  const [courseLecturerRecords, setCourseLecturerRecords] = useState([]);
  const [selectedCourseLecturer, setSelectedCourseLecturer] = useState([]);

  const [duration, setDuration] = useState(0);

  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({ first: 0, rows: 10, page: 0 });

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [openUpdateModalTutorial, setOpenUpdateModalTutorial] = useState(false);
  const [openUpdateModalKKD, setOpenUpdateModalKKD] = useState(false);

  const [key, setKey] = useState("A");

  useEffect(() => {
    setTitle("USAKTI | Absensi"); // Set judul halaman
  }, [setTitle]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getCourseSession();
        await getCourseStudents();
        await getCourseLecturers();
      } catch (error) {
        setToastObj({
          msg: error,
          type: "danger",
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [pagination, key]);

  const paginationTemplate = {
    layout: "PrevPageLink PageLinks NextPageLink ",
    PrevPageLink: (options) => {
      return (
        <button type="button" className="btn border">
          <span className="p-3">Previous</span>
          <Ripple />
        </button>
      );
    },
    NextPageLink: (options) => {
      return (
        <button type="button" className="btn border">
          <span className="p-3">Next</span>
          <Ripple />
        </button>
      );
    },
  };

  const onPageChange = async (event) => {
    setPagination({ first: event.first, rows: event.rows, page: event.page });
  };

  const showSwal = async () => {
    // if (navigator.geolocation) {
    // navigator.geolocation.getCurrentPosition(
    // (position) => {
    // Lokasi diaktifkan, tampilkan SweetAlert
    MySwal.fire({
      title: "Mulai Kelas?",
      text: "Mulai Kelas",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#55ce63",
      confirmButtonText: "MULAI",
      cancelButtonColor: "#d33",
      cancelButtonText: "BATALKAN",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const currentTime = await getCurrentTime();
        await checkIn(currentTime);
      }
    });
    // },
    //   (error) => {
    //     // Lokasi tidak aktif, tampilkan pesan peringatan
    //     MySwal.fire({
    //       icon: "warning",
    //       title: "Oops",
    //       text: "Pengguna tidak mengizinkan akses lokasi, lokasi Universitas akan digunakan",
    //       confirmButtonColor: "#3085d6",
    //       confirmButtonText: "OK",
    //     });
    //   }
    // );
    // } else {
    //   // Geolocation tidak tersedia
    //   MySwal.fire({
    //     icon: "error",
    //     title: "Gagal",
    //     text: "Browser tidak mendukung Geolocation",
    //     confirmButtonColor: "#3085d6",
    //     confirmButtonText: "OK",
    //   });
    // }
  };

  const toggleOpenCreateModal = () => {
    setShowCreateModal(true);
  };

  const toggleOpenCheckOutModal = () => {
    setOpenCheckOutModal(true);
  };

  const toggleOpenUpdateModal = (data) => {
    setOpenUpdateModal(true);
    setSelectedCourseStudent(data);
  };

  const toggleOpenUpdateLecturerModal = (data) => {
    setOpenUpdateLecturerModal(true);
    setSelectedCourseLecturer(data);
  };

  const toggleOpenUpdateModalTutorial = (data) => {
    setOpenUpdateModalTutorial(true);
    setSelectedCourseStudent(data);
  };

  const toggleOpenUpdateModalKKD = (data) => {
    setOpenUpdateModalKKD(true);
    setSelectedCourseStudent(data);
  };

  const toggleOpenDeleteLecturerModal = (data) => {
    setOpenDeleteLecturerModal(true);
    setSelectedCourseLecturer(data);
  };

  const getCourseSession = async () => {
    const response = await axiosInstance.get(
      `${API_URL}/course-sessions/${id}/${course_type}`
    );
    setCourseSession(response.data.data);

    // Set duration
    if (
      response.data.data.status !== 0 &&
      response.data.data.open_at !== null
    ) {
      const result = await getHoursDifference(
        response.data.data.open_at,
        response.data.data.close_at,
        response.data.data.status
      );
      setDuration(result);
    }
  };

  const getHoursDifference = async (startTime, endTime, status) => {
    let now;

    if (status === 1) {
      // ON GOING
      now = new Date();
    } else {
      // FINISHED
      const [endHours, endMinutes] = endTime.split(":").map(Number);
      const inputTime = new Date();
      now = inputTime.setHours(endHours, endMinutes, 0, 0);
    }

    // Convert the start hour
    const [startHours, startMinutes] = startTime.split(":").map(Number);
    const inputTime = new Date();
    inputTime.setHours(startHours, startMinutes, 0, 0); // Set time to 14:06

    // Calculation
    const diffMs = now - inputTime;
    const diffHours = diffMs / (1000 * 60 * 60);

    return diffHours.toFixed(2); // Return hours with 2 decimal places
  };

  const getCourseStudents = async () => {
    const limit = pagination.rows === "All" ? -1 : pagination.rows;
    const response = await axiosInstance.get(
      `${API_URL}/course-students/${id}/${course_type}?search=${search}&page=${
        pagination.page + 1
      }&limit=${limit}`
    );
    setCourseStudents({
      courseStudents: response.data.data,
      totalRecords: response.data.totalRecords,
    });
    setCourseStudentRecords(response.data.data);
  };

  const exportRekap = async () => {
    const response = await axiosInstance.get(
      `${API_URL}/course-students/${id}/${course_type}?search=${search}&page=${
        pagination.page + 1
      }&limit=-1`
    );
    const data = response.data.data;

    const workbook = new excelJS.Workbook();
    const worksheet = workbook.addWorksheet("REKAP_KEHADIRAN Excel");
    // Row 1
    if (course_type.includes("TUTORIAL")) {
      worksheet.mergeCells("A1:H1");
    } else if (course_type.includes("KKD")) {
      worksheet.mergeCells("A1:G1");
    } else {
      worksheet.mergeCells("A1:F1");
    }
    const titleRow = worksheet.getRow(1);
    titleRow.getCell(
      1
    ).value = `REKAP KEHADIRAN ${courseSession.courseGroup.course.name.toUpperCase()}`;

    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // Row 2
    if (course_type.includes("TUTORIAL")) {
      worksheet.mergeCells("A2:H2");
    } else if (course_type.includes("KKD")) {
      worksheet.mergeCells("A2:G2");
    } else {
      worksheet.mergeCells("A2:F2");
    }
    const dateRow = worksheet.getRow(2);
    dateRow.getCell(1).value = `${formatDate(courseSession.date)} - (${
      courseSession.start_time
    } - ${courseSession.end_time})`;

    worksheet.getRow(2).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
    // Row 3
    if (course_type.includes("TUTORIAL")) {
      worksheet.mergeCells("A3:H3");
    } else if (course_type.includes("KKD")) {
      worksheet.mergeCells("A3:G3");
    } else {
      worksheet.mergeCells("A3:F3");
    }
    const lecturerRow = worksheet.getRow(3);
    lecturerRow.getCell(
      1
    ).value = `${courseLecturers.courseLecturers[0].lecturer.name.toUpperCase()} (${
      courseSession.open_at ?? "-"
    } - ${courseSession.close_at ?? "-"})`;

    worksheet.getRow(3).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // Row 4 (Header with 8 columns)
    const headerRow = worksheet.addRow([
      "No",
      "NIM",
      "NAMA MAHASISWA",
      "WAKTU HADIR",
      ...(course_type.includes("TUTORIAL")
        ? ["NILAI PROSES", "NILAI LOGBOOK"]
        : []),
      ...(course_type.includes("KKD") ? ["NILAI PROSES"] : []),
      "KETERANGAN",
      "STATUS",
    ]);

    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    worksheet.columns = [
      { key: "no", width: 5 },
      { key: "nim", width: 15 },
      { key: "nama_mahasiswa", width: 25 },
      { key: "waktu_hadir", width: 20 },
      ...(course_type.includes("TUTORIAL")
        ? [
            { key: "nilai_proses", width: 15 },
            { key: "nilai_logbook", width: 15 },
          ]
        : []),
      ...(course_type.includes("KKD")
        ? [{ key: "nilai_proses", width: 15 }]
        : []),
      { key: "keterangan", width: 30 },
      { key: "status", width: 15 },
    ];

    data.students.forEach((student, index) => {
      const status =
        student.status === 1
          ? "TEPAT WAKTU"
          : student.status === 2
          ? "TERLAMBAT"
          : "TIDAK HADIR";

      let logbookScore;
      let prosesScore;
      let formattedLogbookScore;
      let formattedProsesScore;
      let kkdScore;
      let formattedKkdScore;
      if (course_type.includes("TUTORIAL")) {
        logbookScore =
          student.courseGroupTimetableTutorial?.tutorialSesi?.tutorial?.tutorialLogbookScore?.find(
            (score) => score.student_id === student.student.id
          )?.final_score;

        prosesScore =
          student.courseGroupTimetableTutorial?.tutorialSesi?.tutorial?.tutorialPenilaianProses?.find(
            (score) => score.student_id === student.student.id
          )?.final_score;

        formattedLogbookScore = logbookScore
          ? parseFloat(logbookScore).toFixed(1)
          : "-";

        formattedProsesScore = prosesScore
          ? parseFloat(prosesScore).toFixed(1)
          : "-";
      }

      if (course_type.includes("KKD")) {
        kkdScore = student.courseGroupTimetableKkd?.kkdPenilaianProses?.find(
          (score) => score.student_id === student.student.id
        )?.final_score;
        formattedKkdScore = kkdScore ? parseFloat(kkdScore).toFixed(1) : "0";
      }

      const dataRow = worksheet.addRow({
        no: index + 1,
        nim: student.student.nim,
        nama_mahasiswa: student.student.name,
        waktu_hadir: student.check_in || "-", // Default to "-" if null
        ...(course_type.includes("TUTORIAL") && {
          nilai_proses: formattedProsesScore,
          nilai_logbook: formattedLogbookScore,
        }),
        ...(course_type.includes("KKD") && {
          nilai_proses: formattedKkdScore,
        }),
        keterangan: student.description || "-",
        status,
      });

      let fontColor;
      if (status === "TEPAT WAKTU") {
        fontColor = "00B050"; // Hijau
      } else if (status === "TERLAMBAT") {
        fontColor = "FFBF00"; // Kuning-Oranye
      } else if (status === "TIDAK HADIR") {
        fontColor = "FF0000"; // Merah
      }

      // Terapkan gaya pada setiap sel dalam baris
      dataRow.eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        if (
          (course_type.includes("TUTORIAL") && colNumber === 8) ||
          (course_type.includes("KKD") && colNumber === 7) ||
          (!course_type.includes("TUTORIAL") &&
            !course_type.includes("KKD") &&
            colNumber === 6)
        ) {
          cell.font = {
            color: { argb: fontColor },
          };
        }
      });
    });

    const buf = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buf], { type: "application/octet-stream" }),
      "REKAP_KEHADIRAN.xlsx"
    );
  };

  const getCourseLecturers = async () => {
    const response = await axiosInstance.get(
      `${API_URL}/course-lecturers/${id}/${course_type}`
    );
    setCourseLecturers({
      courseLecturers: response.data.data,
      totalRecords: response.data.totalRecords,
    });
    setCourseLecturerRecords(response.data.data);
  };

  const formatDate = (isoDate) => {
    // Format using moment
    return moment(isoDate).format("DD MMM YYYY");
  };

  function handleFilter(userType, event) {
    if (userType === "MAHASISWA") {
      const newData = courseStudents.courseStudents.students.filter((row) => {
        return (
          row.student.nim
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          row.student.name
            .toLowerCase()
            .includes(event.target.value.toLowerCase())
        );
      });
      setCourseStudentRecords({
        students: newData,
        totalRecords: courseStudents.courseStudents.totalRecords,
      });
    } else {
      const newData = courseLecturers.courseLecturers.filter((row) => {
        return (
          row.lecturer.nim
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          row.lecturer.name
            .toLowerCase()
            .includes(event.target.value.toLowerCase())
        );
      });
      setCourseLecturerRecords(newData);
    }
    setSearch(event.target.value);
  }

  const getCurrentTime = async () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0"); // Add leading zero if needed
    const minutes = String(now.getMinutes()).padStart(2, "0"); // Add leading zero if needed
    return `${hours}:${minutes}`;
  };

  const handleStatus = (status) => {
    if (status === 0) {
      return (
        <span className="badge text-white text-bg-danger">TIDAK HADIR</span>
      );
    } else if (status === 1) {
      return (
        <span className="badge text-white text-bg-success">TEPAT WAKTU</span>
      );
    } else {
      return (
        <span className="badge text-white text-bg-warning">TERLAMBAT</span>
      );
    }
  };

  const checkIn = async (currentTime) => {
    setLoading(true);
    try {
      await axiosInstance.put(
        `${API_URL}/course-attendances/lecturer/check-in/${id}/${course_type}`,
        {
          check_in: currentTime,
        }
      );
      await getCourseSession();
      await getCourseLecturers();
      setLoading(false);
      setToastObj({ msg: "Kelas berhasil dimulai!", type: "success" });
    } catch (error) {
      let errorMessage = "Terjadi kesalahan";
      if (error.response.data.msg != undefined) {
        errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
      } else {
        errorMessage = error.message;
      }
      setLoading(false);
      setToastObj({
        msg: errorMessage,
        type: "danger",
      });
    }
  };

  function handleRowChange(row) {
    setPagination({ first: 0, rows: row, page: 0 });
  }

  return loading === false ? (
    <div className="container-fluid">
      <div className="card mb-4">
        <div className="card-body">
          <h1>Presensi Akademik</h1>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">Presensi Akademik</li>
          </ol>
        </div>
      </div>

      {/* TIMESHEET */}
      <div className="row">
        <div className="col-md-5 mb-4">
          <div className="card">
            <div className="card-body">
              <h6 className="card-title">Timesheet</h6>
              <p style={{ color: "#747474" }}>
                <strong>{courseSession.courseGroup.course.name}</strong>
                <br></br>
                {courseSession.courseTopic.topic} - {courseSession.course_type}{" "}
                - Kelompok {courseSession.courseGroup.group.name}
              </p>
              <div className="punch-det mt-3">
                <p className="m-0" style={{ fontSize: "0.75rem" }}>
                  Absensi
                </p>
                <p style={{ fontSize: "0.75rem" }}>
                  {formatDate(courseSession.date)} ({courseSession.start_time} -{" "}
                  {courseSession.end_time})
                </p>
              </div>
              <div className="punch-info">
                <div
                  className="punch-hours"
                  style={{
                    border:
                      courseSession.status === 1
                        ? "5px solid rgb(0, 224, 11)"
                        : "5px solid #e00000",
                  }}
                >
                  <span>{duration} Jam</span>
                </div>
              </div>
              <div className="punch-btn-section">
                {courseSession.status != 1 ? (
                  <button
                    className="btn btn-success punch-btn"
                    onClick={showSwal}
                  >
                    Masuk
                  </button>
                ) : (
                  <button
                    className="btn btn-danger punch-btn"
                    onClick={toggleOpenCheckOutModal}
                  >
                    Pulang
                  </button>
                )}
              </div>
              <div className="statistics">
                <div className="row">
                  <div className="col-6 text-center">
                    <div className="stats-box">
                      <p className="m-0" style={{ fontSize: "0.75rem" }}>
                        Total Mahasiswa
                      </p>
                      <p className="m-0" style={{ fontSize: "0.75rem" }}>
                        {courseSession.total_registered}
                      </p>
                    </div>
                  </div>
                  <div className="col-6 text-center">
                    <div className="stats-box">
                      <p className="m-0" style={{ fontSize: "0.75rem" }}>
                        Total Hadir
                      </p>
                      <p className="m-0" style={{ fontSize: "0.75rem" }}>
                        {courseSession.total_participants}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body m-3">
          <div className="row">
            <div className="col-md-12 justify-content-end d-flex gap-1">
              {(course_type === "PLENO" || course_type === "PRAKTIKUM") &&
                key !== "A" && (
                  <button
                    className="btn btn-success"
                    onClick={toggleOpenCreateModal}
                  >
                    + Tambah
                  </button>
                )}
              <button className="btn btn-primary" onClick={exportRekap}>
                <i className="fas fa-file-excel"></i> Rekap
              </button>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-4 text-center offset-md-4">
              <h4>Kehadiran</h4>
            </div>
          </div>

          <div className="row">
            <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
              <Nav variant="pills" className="mb-3">
                <Nav.Item>
                  <Nav.Link eventKey="A">Mahasiswa</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="B">Pengajar</Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content>
                {/* TAB KEHADIRAN MAHASISWA */}
                <Tab.Pane eventKey="A">
                  {/* SEARCH */}
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <label>Show</label>
                      <select
                        value={pagination.rows}
                        onChange={(e) => handleRowChange(e.target.value)}
                        className="form-select form-select-sm d-inline-block w-auto ms-2"
                      >
                        {rowsPerPageOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                      <label style={{ marginLeft: "5px" }}>entries</label>
                    </div>
                    <div className="col-md-6 text-end">
                      <label>Search :</label>
                      <input
                        type="text"
                        style={{
                          width: "auto",
                          display: "inline-block",
                          marginLeft: "5px",
                        }}
                        className="form-control form-control-sm"
                        onChange={(event) => handleFilter("MAHASISWA", event)}
                      />
                      <button
                        className="btn btn-primary text-white me-2"
                        style={{ marginLeft: "5px" }}
                        onClick={getCourseStudents}
                      >
                        Cari
                      </button>
                    </div>
                  </div>

                  <div className="table-responsive">
                    {/* Tabel Data MAHASISWA */}
                    <table className="table table-striped mt-3">
                      <thead>
                        <tr>
                          <th>NIM</th>
                          <th>NAMA</th>
                          <th>WAKTU HADIR</th>
                          {[
                            "TUTORIAL (SESI 1)",
                            "TUTORIAL (SESI 2)",
                            "KKD",
                          ].includes(courseSession.course_type) && (
                            <th>NILAI PROSES</th>
                          )}
                          {["TUTORIAL (SESI 2)"].includes(
                            courseSession.course_type
                          ) && <th>NILAI LOGBOOK</th>}
                          <th>FOTO</th>
                          <th>KETERANGAN</th>
                          <th className="text-center">STATUS</th>
                          <th className="text-center">AKSI</th>
                        </tr>
                      </thead>
                      <tbody>
                        {courseStudentRecords.students.length > 0 ? (
                          courseStudentRecords.students.map((item, index) => {
                            const finalScoreProses =
                              [1, 2].includes(
                                item.courseGroupTimetableTutorial?.tutorialSesi
                                  ?.sesi
                              ) &&
                              (() => {
                                const score =
                                  item.courseGroupTimetableTutorial?.tutorialSesi?.tutorial?.tutorialPenilaianProses?.find(
                                    (score) =>
                                      score.student_id === item.student.id
                                  )?.final_score;
                                return score
                                  ? parseFloat(score).toFixed(1)
                                  : "-";
                              })();

                            const finalScoreLogbook =
                              item.courseGroupTimetableTutorial?.tutorialSesi
                                ?.sesi === 2 &&
                              (() => {
                                const score =
                                  item.courseGroupTimetableTutorial?.tutorialSesi?.tutorial?.tutorialLogbookScore?.find(
                                    (score) =>
                                      score.student_id === item.student.id
                                  )?.final_score;
                                return score
                                  ? parseFloat(score).toFixed(1)
                                  : "-";
                              })();

                            const kkdScore =
                              item?.courseGroupTimetableKkd
                                ?.kkdPenilaianProses[0]?.final_score;

                            return (
                              <tr key={index}>
                                <td>{item.student.nim}</td>
                                <td>{item.student.name}</td>
                                <td>{item.check_in ?? "-"}</td>
                                {[
                                  "TUTORIAL (SESI 1)",
                                  "TUTORIAL (SESI 2)",
                                ].includes(courseSession.course_type) && (
                                  <td>{finalScoreProses}</td>
                                )}
                                {["KKD"].includes(
                                  courseSession.course_type
                                ) && (
                                  <td>
                                    {kkdScore
                                      ? parseFloat(kkdScore).toFixed(1)
                                      : "-"}
                                  </td>
                                )}
                                {["TUTORIAL (SESI 2)"].includes(
                                  courseSession.course_type
                                ) && <td>{finalScoreLogbook}</td>}

                                <td>
                                  {item.image ? (
                                    <Image
                                      src={`https://sarjana.fmas.trisakti.ac.id/public/uploads/${item.image}`}
                                      alt="Image"
                                      width="40"
                                      preview
                                    />
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>{item.description ?? "-"}</td>
                                <td>
                                  <div className="d-flex justify-content-center">
                                    {handleStatus(item.status)}
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex gap-1 justify-content-center">
                                    {course_type === "TUTORIAL (SESI 2)" && (
                                      <Link
                                        to={{
                                          pathname: `/akademik/course-attendance/logbook/${id}/${item.student.id}`,
                                        }}
                                        className="btn btn-success text-white btn-sm"
                                      >
                                        <i className="fas fa-clipboard-list"></i>
                                      </Link>
                                    )}
                                    <button
                                      className="btn btn-warning text-white btn-sm"
                                      onClick={
                                        course_type === "TUTORIAL (SESI 1)" ||
                                        course_type === "TUTORIAL (SESI 2)"
                                          ? () =>
                                              toggleOpenUpdateModalTutorial(
                                                item
                                              )
                                          : course_type === "KKD"
                                          ? () => toggleOpenUpdateModalKKD(item)
                                          : () => toggleOpenUpdateModal(item)
                                      }
                                    >
                                      <i className="fa-regular fa-pen-to-square"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center">
                              No Data Available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Paginator dari PrimeReact */}
                  <div className="row">
                    <div className="col-md-6 d-flex align-items-center h-100">
                      <p>
                        Showing {pagination.first + 1} to {""}
                        {pagination.first +
                          courseStudents.courseStudents.students.length}{" "}
                        of {courseStudents.courseStudents.totalRecords} entries
                      </p>
                    </div>
                    <div className="col-md-6">
                      <Paginator
                        first={pagination.first}
                        rows={
                          pagination.rows === "All"
                            ? courseStudentRecords.totalRecords
                            : pagination.rows
                        }
                        totalRecords={courseStudentRecords.totalRecords}
                        onPageChange={onPageChange}
                        template={paginationTemplate}
                      />
                    </div>
                  </div>
                </Tab.Pane>

                {/* TAB KEHADIRAN DOSEN */}
                <Tab.Pane eventKey="B">
                  {/* SEARCH */}
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <label>Show</label>
                      <select
                        value={pagination.rows}
                        onChange={(e) =>
                          handleRowChange(parseInt(e.target.value))
                        }
                        className="form-select form-select-sm d-inline-block w-auto ms-2"
                      >
                        {rowsPerPageOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                      <label style={{ marginLeft: "5px" }}>entries</label>
                    </div>
                    <div className="col-md-6 text-end">
                      <label>Search :</label>
                      <input
                        type="text"
                        style={{
                          width: "auto",
                          display: "inline-block",
                          marginLeft: "5px",
                        }}
                        className="form-control form-control-sm"
                        onChange={(event) => handleFilter("DOSEN", event)}
                      />
                    </div>
                  </div>

                  <div className="table-responsive">
                    {/* Tabel Data DOSEN */}
                    <table className="table table-striped mt-3">
                      <thead>
                        <tr>
                          <th>NIDN</th>
                          <th>NAMA</th>
                          <th>WAKTU HADIR</th>
                          <th>KETERANGAN</th>
                          <th className="text-center">STATUS</th>
                          <th className="text-center">AKSI</th>
                        </tr>
                      </thead>
                      <tbody>
                        {courseLecturerRecords.length > 0 ? (
                          courseLecturerRecords.map((item, index) => (
                            <tr key={index}>
                              <td>{item.lecturer.nim}</td>
                              <td>{item.lecturer.name}</td>
                              <td>{item.check_in ?? "-"}</td>
                              <td>{item.description ?? "-"}</td>
                              <td>
                                <div className="d-flex justify-content-center">
                                  {handleStatus(item.status)}
                                </div>
                              </td>
                              <td>
                                <div className="d-flex gap-1 justify-content-center">
                                  <button
                                    className="btn btn-warning text-white btn-sm"
                                    onClick={() =>
                                      toggleOpenUpdateLecturerModal(item)
                                    }
                                  >
                                    <i className="fa-regular fa-pen-to-square"></i>
                                  </button>
                                  {(course_type === "PLENO" ||
                                    course_type === "PRAKTIKUM") && (
                                    <button
                                      className="btn btn-danger text-white btn-sm"
                                      onClick={() =>
                                        toggleOpenDeleteLecturerModal(item)
                                      }
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center">
                              No Data Available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Paginator dari PrimeReact */}
                  <div className="row">
                    <div className="col-md-6 d-flex align-items-center h-100">
                      <p>
                        Showing {pagination.first + 1} to{" "}
                        {pagination.rows > courseLecturerRecords.length
                          ? courseLecturerRecords.length
                          : pagination.rows}
                        of {courseLecturerRecords.length} entries
                      </p>
                    </div>
                    <div className="col-md-6">
                      <Paginator
                        first={pagination.first}
                        rows={pagination.rows}
                        totalRecords={courseLecturerRecords.length}
                        onPageChange={onPageChange}
                        template={paginationTemplate}
                      />
                    </div>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>

      {showCreateModal && (
        <CreateModal
          toggleModal={setShowCreateModal}
          id={courseSession.courseGroup.id}
          ids={id}
          getCourseLecturers={getCourseLecturers}
          getCourseStudents={getCourseStudents}
          course_type={course_type}
        />
      )}
      {openUpdateModal && (
        <UpdateModal
          toggleModal={setOpenUpdateModal}
          getCourseStudents={getCourseStudents}
          getCourseSession={getCourseSession}
          student={selectedCourseStudent}
          course_type={course_type}
        />
      )}
      {openUpdateLecturerModal && (
        <UpdateLecturerModal
          toggleModal={setOpenUpdateLecturerModal}
          getCourseLecturers={getCourseLecturers}
          lecturer={selectedCourseLecturer}
          course_type={course_type}
        />
      )}
      {openUpdateModalTutorial && (
        <UpdateModalTutorial
          toggleModal={setOpenUpdateModalTutorial}
          id={id}
          getCourseStudents={getCourseStudents}
          student={selectedCourseStudent}
          course_type={course_type}
          tutorial_id={courseSession.tutorialSesi.tutorial_id}
          tutorial_sesi_id={courseSession.tutorialSesi.id}
          period_id={courseSession.period_id}
        />
      )}
      {openUpdateModalKKD && (
        <UpdateModalKKD
          toggleModal={setOpenUpdateModalKKD}
          id={id}
          getCourseStudents={getCourseStudents}
          student={selectedCourseStudent}
          course_type={course_type}
          course_group_timetable_kkd_id={courseSession.id}
          period_id={courseSession.period_id}
        />
      )}
      {openDeleteLecturerModal && (
        <DeleteLecturerModal
          toggleModal={setOpenDeleteLecturerModal}
          getCourseLecturers={getCourseLecturers}
          lecturer={selectedCourseLecturer}
          course_type={course_type}
        />
      )}
      {openCheckOutModal && (
        <CheckOutModal
          toggleModal={setOpenCheckOutModal}
          id={id}
          course_type={course_type}
        />
      )}
    </div>
  ) : (
    <div>
      <div className="row">
        <div
          className="col-md-12 text-center align-center"
          style={{ marginTop: "20%" }}
        >
          <h1>Mohon Tunggu</h1>
        </div>
      </div>
    </div>
  );
};

export default CourseAttendances;
